import { FaAward, FaStar, FaHeart, FaDownload } from "react-icons/fa";

export default {
  wallet: [
    {
      count: 30,
      suffixText: "+",
      body: "Clientes",
    },
    {
      count: 100,
      suffixText: "+",
      body: "Scrapys",
    },
    {
      count: 68,
      suffixText: "+",
      body: "webs",
    },
  ],
};
